import { WorkerBaromoneyHistoryDetail } from '@/entity/WorkerBaromoneyHistoryDetail';
import { getInitialState } from '@/vuex-store/worker-baromoney-history-detail-dialog/state';
export const mutationType = {
    // 필터옵션(조회기간) 수정
    SET_FILTER_OPTION: 'SET_FILTER_OPTION',
    // 정렬옵션 수정
    SET_SORT_OPTION: 'SET_SORT_OPTION',
    // 페이지 넘버 수정 - 필터옵션과는 분리 (필터옵션 deep 변경시 넘버 초기화를 위함)
    SET_PAGE_NUMBER: 'SET_PAGE_NUMBER',
    // 다이얼로그 열기/닫기
    SET_DIALOG_DETAIL: 'SET_DIALOG_DETAIL',
    // 라이더별 바로머니 내역 조회
    GET_WORKER_PROFIT_BY_WORKER_CODE_LIST: 'GET_WORKER_PROFIT_BY_WORKER_CODE_LIST',
    // 라이더별 바로머니 내역 목록 초기화
    RESET_WORKER_PROFIT_BY_WORKER_CODE_LIST: 'RESET_WORKER_PROFIT_BY_WORKER_CODE_LIST',
    // 전체 초기화
    RESET_STORE: 'RESET_STORE',
};
const mutations = {
    [mutationType.SET_FILTER_OPTION](state, payload) {
        Object.entries(payload).forEach(([key, value,]) => {
            state.filterOption[key] = value;
        });
    },
    [mutationType.SET_SORT_OPTION](state, payload) {
        state.sortOption = payload;
    },
    [mutationType.SET_PAGE_NUMBER](state, pageNumber) {
        state.pageNumber = pageNumber;
    },
    [mutationType.SET_DIALOG_DETAIL](state, payload) {
        state.dialogDetail = payload;
        const { fromDate, toDate, } = payload;
        if (fromDate && toDate) {
            state.filterOption = {
                fromDate,
                toDate,
            };
        }
    },
    [mutationType.GET_WORKER_PROFIT_BY_WORKER_CODE_LIST](state, data) {
        state.workerBaromoneyHistoryByWorkerCodeList = data.list.map((value) => new WorkerBaromoneyHistoryDetail(value));
        state.paginationData = data.paginationData;
    },
    [mutationType.RESET_WORKER_PROFIT_BY_WORKER_CODE_LIST](state) {
        state.workerBaromoneyHistoryByWorkerCodeList = [];
    },
    [mutationType.RESET_STORE](state) {
        Object.assign(state, getInitialState());
    },
};
export default mutations;
